const normalizeDate = (date: string) =>  {
    const exploded = date.split('/');

    const parsed = `${exploded[2]}-${exploded[1]}-${exploded[0]}`;

    return parsed;
  }

  export { normalizeDate }